module.exports = __webpack_public_path__ + "images/icon-events-notfound@2x-4f0362c91ef1dbde5459475039660e73.png";